export const redirectToMyPrevisite = async (userId: string | null) => {
    const token = process.env.REACT_APP_MY_API_TOKEN;
    const myApiUrl = `${process.env.REACT_APP_MY_API_URL}/api/my_connect_user/${userId}?token=${token}`;

    try {
        const response = await fetch(myApiUrl, {
            method: 'GET',
            redirect: 'manual',
        });
        const redirectUrl = response.url;

        if (redirectUrl) {
            // Suppression des données locales
            localStorage.removeItem('userToken');
            localStorage.removeItem('userEmail');
            localStorage.removeItem('agencyName');
            localStorage.removeItem('roles');
            localStorage.removeItem('userId');
            localStorage.removeItem('isAdmin');
            localStorage.removeItem('quota');
            localStorage.removeItem('isSsoUser');
            localStorage.removeItem('userMyId');
            localStorage.removeItem('groupement');
            localStorage.removeItem('autoPublish');
            localStorage.removeItem('countUnreadReview');

            // Redirection vers My Previsite
            window.location.href = redirectUrl;
            return true;
        } else {
            console.error('Échec de la connexion SSO', response);
            return false;
        }
    } catch (error) {
        console.error('Erreur lors de la requête SSO :', error);
        return false;
    }
};
